import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axiosInstance from '../../axiosInstance.js';

export const ListquizManagementSlice = createAsyncThunk("listingquiz",async ({status,params}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`listingquiz/${status}?${params}`);
      console.log(response)
        return response.data;
     
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const CreateQuizManagementSlice = createAsyncThunk("createquiz",async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('createquiz',data);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const EditQuizManagementSlice = createAsyncThunk("updatequiz",async ({id,data}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`updatequiz/${id}`,data);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const UpdateStatusQuizManagementSlice = createAsyncThunk("updatestatus/id",async ({id,data}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`updatestatus/${id}`,data);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

const QuizManagementSlice = createSlice({
  name: 'Quiz Management',
  initialState: {
    AllQuiz: [],
    CreateQuiz:[],
    EditQuiz:[],
    UpdateStatusQuiz:[],
    pageNumber:{
      pendingQuiz:1,
      publishedQuiz:1,
      rejectedQuiz:1,
    },
    loading: false,
    error: null,
    validationErrors: [],
  },

  reducers: {
   handleHoldPage: (state, action) => {
  const { field, page } = action.payload;
  console.log(field, page);

  if (!state.pageNumber) {
    state.pageNumber = {};
  }

  state.pageNumber[field] = page;
}
  },
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null; 
      state.validationErrors = []; 
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || []; 
      // toast.error(state.error);
    }

    builder
      .addCase(ListquizManagementSlice.pending,handlePendingState)
      .addCase(ListquizManagementSlice.fulfilled, (state, action) => {
        state.AllQuiz = action.payload.data; 
        state.loading = false;
        // toast.success("Logged Successfully!"); 
      })
      .addCase(ListquizManagementSlice.rejected,handleRejectState)

      .addCase(CreateQuizManagementSlice.pending,handlePendingState)
      .addCase(CreateQuizManagementSlice.fulfilled, (state, action) => {
        state.CreateQuiz = action.payload.data; 
        state.loading = false;
        toast.success("Quiz created successfully!"); 
      })
      .addCase(CreateQuizManagementSlice.rejected,handleRejectState)

      .addCase(UpdateStatusQuizManagementSlice.pending,handlePendingState)
      .addCase(UpdateStatusQuizManagementSlice.fulfilled, (state, action) => {
        state.UpdateStatusQuiz = action.payload.data; 
        state.loading = false;
      })
      .addCase(UpdateStatusQuizManagementSlice.rejected,handleRejectState)

      .addCase(EditQuizManagementSlice.pending,handlePendingState)
      .addCase(EditQuizManagementSlice.fulfilled, (state, action) => {
        state.EditQuiz = action.payload.data; 
        state.loading = false;
      })
      .addCase(EditQuizManagementSlice.rejected,handleRejectState)
  },
});

export const {handleHoldPage} = QuizManagementSlice.actions

export default QuizManagementSlice.reducer;
